import { C, P0, S, abs, fillAt, rotPts } from '../../geometry';

export const bow = {
  name: 'Bow',
  colors: ['#E5484D', '#8E4EC6'],
  draw(m, t) {
    let sL = 1 + 0.03 * S(t * 1.6),
      sR = sL,
      lift = 0,
      droop = 0,
      wave = 2 * S(t * 1.4),
      wv = 0,
      kh = 1,
      pose = P0();
    if (m === 'happy') {
      sL = sR = 0.92 + 0.16 * abs(S(t * 8));
      lift = -3 * abs(S(t * 8));
      wave = 5 * S(t * 10);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the tails ripple and the loops pulse in turn.
    if (m === 'thinking') {
      wv = 1;
      sL = 1 + 0.07 * S(t * 3);
      sR = 1 + 0.07 * S(t * 3 + Math.PI);
    }
    if (m === 'talking') {
      kh = 1 + 0.14 * S(t * 10);
      sL = sR = 1 + 0.04 * S(t * 10);
    }
    if (m === 'surprised') {
      sL = sR = 1.16;
      lift = -6;
      wave = 0.6 * S(t * 26);
    }
    if (m === 'paused') {
      droop = 24 + S(t * 0.8);
      wave = 0;
    }
    const knot = [];
    for (let k = 0; k <= 12; k++) {
      const a = (k / 12) * 2 * Math.PI,
        c = C(a),
        s = S(a);
      knot.push([
        50 + 13 * Math.sign(c) * Math.pow(abs(c), 0.55),
        56 + 10 * kh * Math.sign(s) * Math.pow(abs(s), 0.55),
      ]);
    }
    const loop = [
      [37, 52],
      [26, 40],
      [14, 40],
      [12, 52],
      [16, 66],
      [28, 66],
      [37, 60],
    ];
    const L = rotPts(
      loop.map(([x, y]) => [37 + (x - 37) * sL, 56 + (y - 56) * sL + lift]),
      37,
      56,
      -droop
    );
    const Rl = rotPts(
      loop.map(([x, y]) => [63 - (x - 37) * sR, 56 + (y - 56) * sR + lift]),
      63,
      56,
      droop
    );
    const tailPts = (dir) =>
      [0, 1, 2, 3].map((k) => {
        const f = k / 3,
          x = 50 + dir * (6 + f * 12),
          y = 66 + f * 22;
        return [x + (wv ? 4 * S(t * 5 - k * 1.3) * f : wave * f * dir), y];
      });
    return {
      strokes: [
        { c: 'a', pts: knot },
        { c: 'a', pts: L },
        { c: 'a', pts: Rl },
        { c: 'b', pts: tailPts(-1) },
        { c: 'b', pts: tailPts(1) },
      ],
      eyes: { x: 50, y: 56 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2),
};
